import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const noop = () => () => {};
const defaultCtx = { registerChart: noop, module: null };
const DashboardContext = createContext(defaultCtx);

// Make the values available to any descendant DashboardCard
export const DashboardContextProvider = ({ children, setChartRefs: onChartRefChange, module }) => {
  const [chartRefs, setChartRefs] = useState([]);

  const registerChart = useCallback((ref) => {
    if (!ref) return noop;
    setChartRefs((prev) => [...prev, ref]);
    return () => setChartRefs((prev) => prev.filter((r) => r !== ref));
  }, []);

  useEffect(() => {
    if (onChartRefChange) {
      onChartRefChange(chartRefs);
    }
  }, [chartRefs, onChartRefChange]);

  return <DashboardContext.Provider value={{ registerChart, module }}>{children}</DashboardContext.Provider>;
};

export const useDashboardContext = () => useContext(DashboardContext);
